import TipsHeadline from './TipsHeadline';

export default TipsHeadline;
